import { useEffect, useRef, useState } from 'react';
import { Alert, Box } from '@mui/material';

let scriptPromise;

const loadTurnstile = () => {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (!scriptPromise) {
        scriptPromise = new Promise((resolve, reject) => {
            const existing = document.querySelector('script[data-nefropolis-turnstile]');
            if (existing) {
                existing.addEventListener('load', () => resolve(window.turnstile), { once: true });
                existing.addEventListener('error', reject, { once: true });
                return;
            }
            const script = document.createElement('script');
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
            script.async = true;
            script.defer = true;
            script.dataset.nefropolisTurnstile = 'true';
            script.onload = () => resolve(window.turnstile);
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }
    return scriptPromise;
};

const TurnstileWidget = ({ action, onVerify }) => {
    const container = useRef(null);
    const callback = useRef(onVerify);
    const [failed, setFailed] = useState(false);
    const sitekey = process.env.REACT_APP_TURNSTILE_SITE_KEY;

    useEffect(() => { callback.current = onVerify; }, [onVerify]);

    useEffect(() => {
        if (!sitekey || !container.current) return undefined;
        let widgetId;
        let cancelled = false;
        loadTurnstile().then(turnstile => {
            if (cancelled || !container.current) return;
            widgetId = turnstile.render(container.current, {
                sitekey,
                action,
                theme: 'auto',
                callback: token => callback.current(token),
                'expired-callback': () => callback.current(''),
                'error-callback': () => { setFailed(true); callback.current(''); }
            });
        }).catch(() => setFailed(true));
        return () => {
            cancelled = true;
            if (widgetId !== undefined && window.turnstile) window.turnstile.remove(widgetId);
        };
    }, [action, sitekey]);

    if (!sitekey)
        return <Alert severity="warning">La verificación de seguridad no está configurada.</Alert>;
    return (
        <Box sx={{ my: 2 }}>
            {failed && <Alert severity="error" sx={{ mb: 1 }}>No se pudo cargar la verificación. Intenta de nuevo.</Alert>}
            <div ref={container} />
        </Box>
    );
};

export default TurnstileWidget;
